export default function (splitText, lines = true, words = false, lineClass = 'line-inner', wordClass = 'word-inner') {

	const splitWords = ($lineWords, $inner) => {
		for (let k = 0; k < $lineWords.length; k++) {
			const $lineWord = $lineWords[k];

			if (words) {
				const $innerWord = document.createElement('div');
				$innerWord.classList.add(wordClass);
				$innerWord.innerHTML = $lineWord.innerHTML;
				$lineWord.innerHTML = '';
				$lineWord.appendChild($innerWord);
			}

			$inner.appendChild($lineWord);
			if (k < $lineWords.length - 1) {
				const $space = document.createElement('div');
				$space.classList.add('space');
				$space.setAttribute('style', $lineWord.getAttribute('style'));
				$space.innerHTML = '&nbsp;';
				$inner.appendChild($space);
			}
		}
	};

	if (lines) {
		const $lines = splitText.lines;
		for (let i = 0; i < $lines.length; i++) {
			const $line = $lines[i];
			const lineContents = $line.innerHTML;
			const $inner = document.createElement('div');
			$inner.classList.add(lineClass);

			if (splitText.words.length) {
				const $lineWords = [...$line.children];
				splitWords($lineWords, $inner);
			} else {
				$line.innerHTML = '';
				$inner.innerHTML = lineContents;
			}

			$line.appendChild($inner);
		}
	} else if (words && splitText.words.length) {
		const $lines = splitText.lines;
		for (let i = 0; i < $lines.length; i++) {
			const $line = $lines[i];
			const $lineWords = [...$line.children];
			splitWords($lineWords, $line);
		}
	}
}
